import React from "react";
import { ChevronDownIcon } from "@heroicons/react/24/outline";

function DexKor() {
  return (
    <div className="-m-2.5 mt-12 overflow-auto">
      <div className="mx-6 my-2">
        <div className="font-bold text-2xl text-start">What is DexKor?</div>
        <p className="text-sm text-gray-700 pt-1 text-start">
          How DexKor works, what it can do for your business and what makes it
          different to other solutions.
        </p>
        <div className="pt-5 flex items-center gap-3">
          <img
            className="w-10 h-10 border-2 border-white rounded-full"
            src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/49/Elon_Musk_2015.jpg/408px-Elon_Musk_2015.jpg"
            alt=""
          />
          <div className="flex flex-col text-sm text-gray-700 text-start">
            <div>Written by Anish Dhakal</div>
            <div>Updated over a month ago</div>
          </div>
        </div>
        <div className="font-normal text-base mt-6">
          <button className="flex justify-between items-center w-full px-3 py-2 border rounded-lg shadow">
            <span>Table of contents</span>
            <ChevronDownIcon className="h-4 w-4" strokeWidth={2} />
          </button>
        </div>
        <div className="mt-6 text-start font-semibold text-2xl">
          What can I do with DexKor?
        </div>
        <p className="mt-3 text-start text-sm">
          Small businesses and startups to mid-market companies. Intercom offers
          three plans to cater for all your needs — whether you're just starting
          out, or you have a large support team and established operations.
        </p>
      </div>
    </div>
  );
}

export default DexKor;
